const COOKIE_CONSENT_KEY = 'cookie_consent';
const COOKIE_MAX_AGE_DAYS = 365;

function getCookieDomain() {
  const host = window.location.hostname;
  if (host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    return '';
  }
  if (host.endsWith('.pulseads.ru') || host === 'pulseads.ru') {
    return '.pulseads.ru';
  }
  return '';
}

export function setConsent(value) {
  const date = new Date();
  date.setTime(date.getTime() + COOKIE_MAX_AGE_DAYS * 24 * 60 * 60 * 1000);
  const domain = getCookieDomain();
  const domainPart = domain ? `; Domain=${domain}` : '';

  document.cookie = `${COOKIE_CONSENT_KEY}=${value}; expires=${date.toUTCString()}; Path=/${domainPart}; SameSite=Lax`;

  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
    localStorage.setItem(`${COOKIE_CONSENT_KEY}_expires`, String(date.getTime()));
  } catch (e) {
    // Ignore storage errors.
  }
}

export function getConsent() {
  const name = `${COOKIE_CONSENT_KEY}=`;
  const parts = document.cookie.split(';');

  for (let i = 0; i < parts.length; i += 1) {
    const item = parts[i].trim();
    if (item.indexOf(name) === 0) {
      return item.substring(name.length);
    }
  }

  try {
    const value = localStorage.getItem(COOKIE_CONSENT_KEY);
    const expires = Number(localStorage.getItem(`${COOKIE_CONSENT_KEY}_expires`) || 0);
    if (value && expires && expires > Date.now()) {
      return value;
    }
  } catch (e) {
    // Ignore storage errors.
  }

  return null;
}
